import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { shallowEqual } from "react-redux";
import {
  PaymentMode,
  DeliveryType,
  ShipmentStatus,
  ShipmentService,
  ShipmentInterface,
  BusinessUnitInterface,
} from "../../interfaces";

interface PriceCalculatorState {
  shipmentDraft: Partial<ShipmentInterface>;
}

const initialState: PriceCalculatorState = {
  shipmentDraft: {
    pieces: [],
    items: [],
    deliveryType: DeliveryType.AT_OFFICE,
    paymentMode: PaymentMode.COD,
    service: ShipmentService.STANDARD,
    status: ShipmentStatus.DRAFT,
  },
};

export const priceCalculatorSlice = createSlice({
  name: "priceCalculator",
  initialState,
  reducers: {
    setPriceCalculatorDraft: (
      state,
      action: PayloadAction<Partial<BusinessUnitInterface>>
    ) => {
      // T5: same guard as setShipmentCreateDraft; here the draft is a single
      // object, not an indexed entry.
      const next = {
        ...state.shipmentDraft,
        ...action.payload,
      };
      if (!shallowEqual(next, state.shipmentDraft)) {
        state.shipmentDraft = next;
      }
    },
    clearPriceCalculator: (state) => {
      state.shipmentDraft = initialState.shipmentDraft;
    },
  },
});

export const { clearPriceCalculator, setPriceCalculatorDraft } =
  priceCalculatorSlice.actions;

export default priceCalculatorSlice.reducer;
